var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReferenceDatas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    id: "document",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.716,
    x2: 5.496,
    y1: 14.223,
    y2: 14.223
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.716,
    x2: 5.496,
    y1: 10.037,
    y2: 10.037
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.251,
    x2: 5.496,
    y1: 5.86,
    y2: 5.86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9086,0.7498 C12.9086,0.7498 5.2316,0.7538 5.2196,0.7538 C2.4596,0.7708 0.7506,2.5868 0.7506,5.3568 L0.7506,14.5528 C0.7506,17.3368 2.4726,19.1598 5.2566,19.1598 C5.2566,19.1598 12.9326,19.1568 12.9456,19.1568 C15.7056,19.1398 17.4156,17.3228 17.4156,14.5528 L17.4156,5.3568 C17.4156,2.5728 15.6926,0.7498 12.9086,0.7498 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReferenceDatas);
export default __webpack_public_path__ + "static/media/icon-reference-datas.500c12ff1aa2b2033ed27e90c2c17a7a.svg";
export { ForwardRef as ReactComponent };